// fixed header menu on scroll
var body = document.getElementsByTagName("BODY")[0];
var siteHeader = document.getElementsByClassName('header--main')[0];
var siteHeaderHeight = siteHeader.offsetHeight;

// if scrolled past header, add class
window.addEventListener('scroll', function() {
 if ( window.window.pageYOffset > siteHeaderHeight + 100  ) {
  body.classList.add('header--fixed');
 }
 else {
  body.classList.remove('header--fixed');
 }

});